import React from 'react';
import {Box, VStack} from 'native-base';
import {message as t} from '../../../../../utils/messages';
import {StyleProp, TextStyle} from 'react-native';
import {IHistoryDetail} from '../../../../../interfaces/dtos';
import SectionItem from './Item';

interface ISectionProps {
  detail: IHistoryDetail;
  style?: StyleProp<TextStyle>;
}

const DetailSection = (props: ISectionProps) => {
  const {detail, style} = props;
  const labelColor = '#06355E';
  const valueColor = '#06355E';
  const alternateColor = '#F8F8F8';

  const getAmount = () => {
    if (detail.amount) {
      if (detail.amount.foreign) {
        return detail.amount.foreign;
      }
      if (detail.amount.local) {
        return detail.amount.local;
      }
    }
    return '';
  };

  const getCurrency = () => {
    if (detail.amount) {
      if (detail.amount.foreign) {
        return t('history-detail-item-currency-foreign-value');
      }
      if (detail.amount.local) {
        return t('history-detail-item-currency-local-value');
      }
    }
    return '';
  };

  return (
    <Box flex={1} style={style}>
      <VStack marginTop={5} marginBottom={5}>
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-bank-label')}
          valueColor={valueColor}
          value={detail.bank}
          backgroundColor={alternateColor}
        />
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-account-label')}
          valueColor={valueColor}
          value={detail.account}
        />
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-currency-label')}
          valueColor={valueColor}
          value={getCurrency()}
          backgroundColor={alternateColor}
        />
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-reference-label')}
          valueColor={valueColor}
          value={detail.reference}
        />
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-date-label')}
          valueColor={valueColor}
          value={detail.dateAt}
          backgroundColor={alternateColor}
        />
        <SectionItem
          labelColor={labelColor}
          label={t('history-detail-item-amount-label')}
          valueColor={valueColor}
          value={getAmount()}
        />
        {detail.comments && detail.comments.trim() !== '' && (
          <SectionItem
            labelColor={labelColor}
            label={t('history-detail-item-comments-label')}
            valueColor={valueColor}
            value={detail.comments}
            backgroundColor={alternateColor}
            multiline={true}
          />
        )}
      </VStack>
    </Box>
  );
};
export default DetailSection;
